<template>
    <div 
        :class="className"
        :style="styleObj"
    ></div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "help",
    },
    color:{
        type:String,
        default:"white",
    },
    size:{
        type:String,
        default:"1.5",
    },
    customStyle:{
        type:Object
    },
    dashboard:{
        type:Boolean
    },
    genericColor:{
      type:Boolean
    }
  },
  data: () => {
    return {
      className: "",
      styleObj:{
          color:"",
          fontSize:"",
          marginLeft:"",
          paddingRight:""
      },
    };
  },
  created() {
    this.className = `workd-icon-${this.name}`;
    if(this.dashboard){
        this.styleObj.color=this.color
        this.styleObj.fontSize=this.size+"rem"
        this.styleObj.marginLeft=`-${this.size/3}rem`
        this.styleObj.paddingRight=`${this.size/3}rem`
    }
    else{
        this.styleObj.color=this.color
        this.styleObj.fontSize=this.size+"rem"
        this.styleObj.marginLeft=`-${0}rem`
        this.styleObj.paddingRight=`${0}rem`
    }
    if(this.customStyle){
        this.styleObj=Object.assign(this.styleObj,this.customStyle)
    }
    if(this.genericColor){
      delete this.styleObj.color
    }
  },
};
</script>

<style scoped>
</style>>
